// Fetch Request
import fetch from '../../../core/fetch';

// Toaster
import { toastr } from 'react-redux-toastr';
import history from '../../../core/history';

// Redux Action
//import { setLoaderStart, setLoaderComplete } from '../../../actions/loader/loader';

async function submit(values, dispatch) {
  if (values.content == null || values.content == '<p><br></p>' || values.content == '<p> </p>') {
    toastr.error("Error Occurred", "Please Add Content");
  }
  else {

    //dispatch(setLoaderStart('editBlog'));

    const mutation = `
  mutation updateBlogDetails(
    $id: Int,
    $metaTitle: String,
    $metaDescription: String,
    $pageUrl: String,
    $pageTitle: String,
    $content: String,
    $footerCategory: String,
    $coverPhoto: Int
  ) {
    updateBlogDetails(
      id: $id,
      metaTitle: $metaTitle,
      metaDescription: $metaDescription,
      pageUrl: $pageUrl,
      pageTitle: $pageTitle,
      content: $content,
      footerCategory: $footerCategory,
      coverPhoto: $coverPhoto
    ) {
        status
    }
  }
`;

    let variables = {
      id: values.id,
      metaTitle: values.metaTitle,
      metaDescription: values.metaDescription,
      pageUrl: values.pageUrl,
      pageTitle: values.pageTitle,
      content: values.content,
      footerCategory: values.footerCategory,
      coverPhoto: values.coverPhoto
    };

    let body = JSON.stringify({
      query: mutation,
      variables
    });
    
    const resp = await fetch('/graphql', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body,
      credentials: 'include',
    });

    const { data } = await resp.json();

    if (data.updateBlogDetails.status === "success") {
      //dispatch(setLoaderComplete('editBlog'));
      toastr.success("Update Blog", "Changes Saved");
      history.push('/siteadmin/content-management');
    }
    else if (data.updateBlogDetails.status === 'URL exist') {
      toastr.error("Added Blog Failed", "The page URL already exist!");
    }
    else {
      toastr.error("Update Blog", "Update failed");
    }
  }

}

export default submit;



// WEBPACK FOOTER //
// src/components/siteadmin/EditBlogDetails/submit.js